var overflowTimeout;

function initFeaturedBlogs() {
const allFeaturedBlogs = document.querySelectorAll('.featured-article-slider');
const allBackBtnsBlog = document.querySelectorAll('.swiper-blog-prev');
const allNextBtnsBlog = document.querySelectorAll('.swiper-blog-next');

for(i=0; i< allFeaturedBlogs.length; i++) {
    allFeaturedBlogs[i].classList.add('swiper-blog-' + i);
    allBackBtnsBlog[i].classList.add('swiper-blog-prev-' + i);
    allNextBtnsBlog[i].classList.add('swiper-blog-next-' + i);

    var slider = new Swiper('.swiper-blog-' + i, {
          spaceBetween: 30,
          mousewheel: {
            forceToAxis	: true
          },
          navigation: {
            nextEl: `.swiper-blog-next-${i}`,
            prevEl: `.swiper-blog-prev-${i}`,
          },
          freeMode: {
            enabled: true,
            sticky: true,
          },
          scrollbar: {
            el: '.swiper-scrollbar',
          },

          breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 15
            },
            749: {
                slidesPerView: 2.2,
                spaceBetween: 20
            },
            990: {
                slidesPerView: 3.1
            }
          },
          on: {
            setTransition: function (e) {
              document.body.classList.add('overscroll-x-none');
              window.clearTimeout(overflowTimeout);
              overflowTimeout = window.setTimeout(function(){
                document.body.classList.remove('overscroll-x-none');
              }, 300); 
            }      
           }
    });
}
}

initFeaturedBlogs();